<template>
<!-- 供应商管理 -->
    <div class="declare-view">
        <div class="table-title">
            <Row type="flex">
                <div class="boxs-div" style="margin-right: 20px">
                    <span class="input-label">供应商名称：</span>
                    <span class="Cascader">
                        <Input placeholder="请输入供应商名称"
                            style="width: 240px"
                            v-model="productByClassifyVar.supplierName"/>
                    </span>
                </div>
                <div class="boxs-div">
                    <span class="input-label">供应商编码：</span>
                    <span class="Cascader">
                        <Input placeholder="请输入供应商编码"
                            v-model="productByClassifyVar.supplierNo"/>
                    </span>
                    <Button
                        style="margin-left: 16px"
                        type="primary"
                        @click="handleSearch">
                        搜索
                    </Button>
                    <Button
                        style="margin-left: 16px"
                        @click="handleReset">
                        重置
                    </Button>
                </div>

            </Row>
        </div>
        <div style="margin-top: 14px">
            <div style="margin-bottom: 16px">
                <Button @click="addSupplier" type="primary">+新增供应商</Button>
            </div>
            <Table
                :columns="columns"
                :data="list"
                :height="520"
                ref="list">
                <template slot-scope="{ row }" slot="action">
                    <Button size="small" type="primary" @click="editSupplier(row)">编辑</Button>
                </template>
            </Table>
            <div class="pages-footer">
                <Page
                    :current="productByClassifyVar.pageNumber"
                    :total="listTotal"
                    show-sizer
                    :page-size="productByClassifyVar.pageSize"
                    @on-page-size-change="getChangePageSize"
                    @on-change="getChangePageNum"/>
            </div>
        </div>
    </div>
</template>

<script>
import { adminGetSupplierList } from '@/graphql/graphql.js';

export default {
    beforeRouteEnter(to, from, next) {
        if (from.fullPath.indexOf('?id') <= 1) {
            window.sessionStorage.removeItem('currentPage');
            next();
        } else {
            next(vm => {
                vm.productByClassifyVar.pageNumber = 1;
            });
        }
    },
    data() {
        return {
            productByClassifyVar: {
                pageNumber: 1,
                pageSize: 20,
                supplierName: '',
                supplierNo: ''
            },
            list: [],
            listTotal: 0,
            columns: [
                {
                    title: '供应商名称',
                    key: 'supplierName',
                    minWidth: 180
                },
                {
                    title: '供应商编码',
                    key: 'supplierNo'
                },
                {
                    title: '联系人姓名',
                    key: 'username'
                },
                {
                    title: '联系人电话',
                    key: 'mobile'
                },
                {
                    title: '密码',
                    key: 'password'
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 120
                }
            ],
            product: {},
            model: false
        };
    },
    mounted() {
        const currentPage = window.sessionStorage.getItem('currentPage');
        if (currentPage) {
            this.productByClassifyVar.pageNumber = Number(currentPage);
        } else {
            this.productByClassifyVar.pageNumber = 1;
        }
        this.getSupplierList();
    },
    methods: {
        // 添加供应商
        addSupplier() {
            this.$router.push('/index/supplier/add');
        },
        editSupplier(row) {
            window.sessionStorage.setItem('currentPage', this.productByClassifyVar.pageNumber);
            this.$router.push({
                path: '/index/supplier/add',
                query: {
                    id: row.id
                }
            });
        },
        getSupplierList() {
            this.$apollo.query({
                query: adminGetSupplierList,
                context: { useApi1: false },
                variables: {
                    condi: this.productByClassifyVar
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.adminGetSupplierList;
                if (data && data.data && data.code === 200) {
                    this.listTotal = data.total;
                    this.list = data.data;
                }
            });
        },
        handleSearch() {
            this.productByClassifyVar.pageNumber = 1;
            this.getSupplierList();
        },
        handleReset() {
            this.productByClassifyVar.pageNumber = 1;
            this.productByClassifyVar.supplierName = '';
            this.productByClassifyVar.supplierNo = '';
            this.getSupplierList();
        },
        getChangePageNum(val) {
            this.productByClassifyVar.pageNumber = val;
            this.getSupplierList();
        },
        // pagesize 变化
        getChangePageSize(size) {
            this.productByClassifyVar.pageSize = size;
            this.getSupplierList();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/supplier/index.vue